import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-56d4a3ec"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "greeting-manager-container"
};
const _hoisted_2 = {
  class: "box"
};
const _hoisted_3 = {
  class: "account-name"
};
const _hoisted_4 = {
  class: "add-account"
};
const _hoisted_5 = {
  class: "pagination-box"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  key: 0,
  class: "mark"
};
const _hoisted_8 = {
  class: "news-form-title"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1));
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { getAllReplyDataById, getWelcomeReplyByAccountId, saveReplyById } from '@/api/greeting';
import { ElMessage } from 'element-plus';
import textGreeting from './components/text-greeting';
import imageGreeting from './components/image-greeting';
import urlDialog from '@/components/UrlDialog';
import newsGreeting from './components/news-greeting';
import { Plus, ZoomIn, Delete } from '@element-plus/icons-vue';
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const {
      path
    } = route.params;

    // 获取当前公众号id
    const accountId = ref(route.params.accountId);
    // 当前公众号的自动回复列表
    const greetingList = ref([]);
    // 当前公众号的自动回复列表总数
    const total = ref(0);
    // 当前页码
    const currentPage = ref(1);
    // 每一页的个数
    const pageSize = ref(8);
    // 当前回复类型
    const replyType = ref('text');

    /**
     * 获取欢迎词回复消息
     */
    const welcomeReply = ref({});
    const welcomeState = ref(false);
    const getWelcomeReplyData = async () => {
      const res = await getWelcomeReplyByAccountId(accountId.value);
      welcomeReply.value = res;
    };
    const editWelcomeHandler = () => {
      isVisible.value = true;
      welcomeState.value = true;
      form.value = {
        keyword: 'welcome',
        replyType: replyType.value,
        ...welcomeReply.value
      };
      if (welcomeReply.value && welcomeReply.value.replyType === 'image') {
        currentSelectImage.value.url = welcomeReply.value.note;
      }
      if (welcomeReply.value && welcomeReply.value.replyType === 'news') {
        const notes = JSON.parse(welcomeReply.value.note);
        newsGroupNum.value = notes.length;
        notes.forEach((item, index) => {
          for (const key in item) {
            form.value = {
              ...form.value,
              [`${key}${index + 1}`]: item[key]
            };
          }
        });
      }
    };

    /**
     * 获取当前公众号的自动回复消息
     */
    const getGreetingData = async () => {
      const res = await getAllReplyDataById({
        accountId: accountId.value,
        currentPage: currentPage.value,
        pageSize: pageSize.value,
        replyType: replyType.value
      });
      greetingList.value = res.records;
      total.value = res.total;
      await getWelcomeReplyData();
    };

    /**
     * 分页点击
     */
    const handleCurrentChange = async value => {
      currentPage.value = value;
      getGreetingData();
    };
    watch(replyType, async () => {
      await getGreetingData();
    }, {
      immediate: true
    });

    /**
     * 新增文本回复消息
     */
    const addGreetingHandler = () => {
      isVisible.value = true;
    };
    const activeName = ref('news');
    const handleClick = async event => {
      greetingList.value = [];
      replyType.value = event.paneName;
      activeName.value = event.paneName;
      form.value.replyType = event.paneName;
      await getGreetingData();
    };

    // 是否显示dialog
    const isVisible = ref(false);

    /**
     * 切换dialog显示
     * @param {*} val
     */
    const changeDialogVisible = val => {
      isVisible.value = val;
    };

    // 表单
    const form = ref({
      replyType: 'text',
      keyword: '',
      value: ''
      // title: '',
      // description: '',
      // picUrl: '',
      // url: ''
    });

    /**
     * 添加一组
     */
    const title = ref([{
      select: false
    }]);
    const addGroupHandler = () => {
      var _formEl$value;
      newsGroupNum.value++;
      (_formEl$value = formEl.value) === null || _formEl$value === void 0 || _formEl$value.clearValidate('keyword');
      title.value.push({
        select: false
      });
    };
    watch(() => form.value.replyType, value => {
      replyType.value = value;
      activeName.value = value;
    }, {
      immediate: true
    });

    // 校验规则
    const rules = ref({
      keyword: [{
        required: true,
        message: '关键字不能为空',
        trigger: 'blur'
      }],
      value: [{
        required: true,
        message: '内容不能为空',
        trigger: 'blur'
      }]
    });

    // form 实例
    const formEl = ref(null);

    /**
     * 提交
     */
    const createGreetingHandler = async () => {
      if (!formEl.value) return;
      if (form.value.keyword === 'welcome' && !welcomeState.value) {
        ElMessage({
          type: 'warning',
          message: '欢迎词回复需要在特定按钮添加修改'
        });
        return;
      }
      await formEl.value.validate(async (valid, fields) => {
        if (valid) {
          let data;
          if (form.value.replyType === 'text') {
            data = {
              ...form.value
            };
          } else if (form.value.replyType === 'image') {
            data = {
              ...form.value,
              value: currentSelectImage.value.media_id,
              note: currentSelectImage.value.url
            };
          } else if (form.value.replyType === 'news') {
            const note = [];
            for (let i = 0; i < newsGroupNum.value; i++) {
              note.push({
                title: form.value[`title${i + 1}`],
                description: form.value[`description${i + 1}`],
                picUrl: form.value[`picUrl${i + 1}`],
                url: form.value[`url${i + 1}`]
              });
              data = {
                replyType: form.value.replyType,
                keyword: form.value.keyword,
                note: JSON.stringify(note)
              };
            }
          }
          await saveReplyById({
            accountId: accountId.value,
            ...data
          });
          await getGreetingData();
          isVisible.value = false;
          ElMessage({
            type: 'success',
            message: '操作成功'
          });
        }
      });
    };

    /**
     * 格式化表单方法
     */
    const resetForm = () => {
      form.value = {
        replyType: form.value.replyType,
        keyword: '',
        value: ''
        // title: '',
        // description: '',
        // picUrl: '',
        // url: '',
        // ...form.value
      };
      newsGroupNum.value = 1;
      formEl.value.resetFields();
    };

    /**
     * 监听dialog的显示隐藏,格式化表单
     */
    watch(isVisible, val => {
      if (!val) {
        form.value = {
          replyType: form.value.replyType,
          keyword: '',
          value: ''
        };
        currentSelectImage.value = {};
        welcomeState.value = false;
      }
    });

    /**
     * 修改
     */
    const editGreetingHandler = raw => {
      form.value = {
        ...raw
      };
      if (raw.replyType === 'image') {
        currentSelectImage.value.url = raw.note;
        currentSelectImage.value.media_id = raw.value;
      }
      if (raw.replyType === 'news') {
        const notes = JSON.parse(raw.note);
        newsGroupNum.value = notes.length;
        notes.forEach((item, index) => {
          for (const key in item) {
            form.value = {
              ...form.value,
              [`${key}${index + 1}`]: item[key]
            };
          }
        });
      }
    };

    // 图片选择显示
    const imageSelectVisible = ref(false);

    /**
     * 点击图片选择
     */

    const imageSelectHandler = () => {
      imageSelectVisible.value = true;
    };

    /**
     * 图片选择后回调函数
     */

    const currentSelectImage = ref({});
    const imageSelected = item => {
      currentSelectImage.value = item;
    };
    const markShow = ref(false);
    const delCurrentSelectImage = () => {
      currentSelectImage.value = {};
    };
    const isPreview = ref(false);
    const previewCurrentSelectImage = () => {
      isPreview.value = true;
    };

    // 图文有几组
    const newsGroupNum = ref(1);
    watch(newsGroupNum, value => {
      let newRules = {};
      for (let i = 0; i < newsGroupNum.value; i++) {
        newRules = {
          ...newRules,
          [`title${i + 1}`]: [{
            required: true,
            message: '标题不能为空',
            trigger: 'blur'
          }],
          [`description${i + 1}`]: [{
            required: true,
            message: '描述不能为空',
            trigger: 'blur'
          }],
          [`picUrl${i + 1}`]: [{
            required: true,
            message: '图片路径不能为空',
            trigger: 'blur'
          }],
          [`url${i + 1}`]: [{
            required: true,
            message: '跳转路径不能为空',
            trigger: 'blur'
          }]
        };
      }
      rules.value = {
        ...rules.value,
        ...newRules
      };
      // formEl.value?.resetFields()
      // setTimeout(() => {
      //   formEl.value?.resetFields()
      // }, 10)
    }, {
      immediate: true
    });

    // watch(
    //   () => Object.keys(form.value).length,
    //   (value) => {
    //     console.log(value)
    //     console.log(312321)
    //     formEl.value?.resetFields()
    //   },
    //   {
    //     immediate: true,
    //     deep: true
    //   }
    // )

    // 是否选择图文素材
    const isSelectNewsVisible = ref(false);

    // 是否选择地址url
    const isUrlSelectVisible = ref(false);
    // 设置是否选择图文素材显示隐藏
    const changeSelectNewsVisible = value => {
      isSelectNewsVisible.value = value;
    };

    // 确认选择地址url
    const onUrlSelectConfirm = val => {
      form.value[`url${newsGroupNum.value}`] = val.url + path;
      isUrlSelectVisible.value = false;
    };

    /**
     * 选择图文素材点击
     */
    const checkNewsPublishHandler = item => {
      isSelectNewsVisible.value = false;
      // newsGroupNum.value++

      form.value[`title${newsGroupNum.value}`] = item.title;
      form.value[`description${newsGroupNum.value}`] = item.digest;
      form.value[`picUrl${newsGroupNum.value}`] = item.thumb_url;
      form.value[`url${newsGroupNum.value}`] = item.url;
      title.value[newsGroupNum.value - 1].select = true;
    };
    const isUrlTextSelectVisible = ref(false);
    const onUrlTextSelectConfirm = val => {
      form.value.value += `<a href='${val.url}${path}'>${val.name}</a>`;
      isUrlTextSelectVisible.value = false;
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "title-card",
        shadow: "never"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$route.params.accountName), 1), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
          type: "success",
          onClick: editWelcomeHandler
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(welcomeReply.value ? '修改欢迎回复' : '新增欢迎回复'), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: addGreetingHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 新增消息回复 ")]),
          _: 1
        })])])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tabs, null, {
          default: _withCtx(() => [_createVNode(_component_el_tabs, {
            modelValue: activeName.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => activeName.value = $event),
            type: "card",
            class: "demo-tabs",
            onTabClick: handleClick
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
              label: "文本回复消息",
              name: "text"
            }, {
              default: _withCtx(() => [activeName.value === 'text' ? (_openBlock(), _createBlock(_unref(textGreeting), {
                key: 0,
                greetingList: greetingList.value,
                isVisible: isVisible.value,
                onChangeDialogVisible: changeDialogVisible,
                onGetData: getGreetingData,
                onEditGreetingHandler: editGreetingHandler
              }, null, 8, ["greetingList", "isVisible"])) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_tab_pane, {
              label: "图片回复消息",
              name: "image"
            }, {
              default: _withCtx(() => [activeName.value === 'image' ? (_openBlock(), _createBlock(_unref(imageGreeting), {
                key: 0,
                greetingList: greetingList.value,
                modelValue: imageSelectVisible.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => imageSelectVisible.value = $event),
                onImageSelected: imageSelected,
                onGetData: getGreetingData,
                onEditGreetingHandler: editGreetingHandler,
                onChangeDialogVisible: changeDialogVisible
              }, null, 8, ["greetingList", "modelValue"])) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_tab_pane, {
              label: "图文回复消息",
              name: "news"
            }, {
              default: _withCtx(() => [activeName.value === 'news' ? (_openBlock(), _createBlock(_unref(newsGreeting), {
                key: 0,
                greetingList: greetingList.value,
                onGetData: getGreetingData,
                isSelectNewsVisible: isSelectNewsVisible.value,
                onChangeSelectNewsVisible: changeSelectNewsVisible,
                onChangeDialogVisible: changeDialogVisible,
                onEditGreetingHandler: editGreetingHandler,
                onCheckNewsPublishHandler: checkNewsPublishHandler
              }, null, 8, ["greetingList", "isSelectNewsVisible"])) : _createCommentVNode("", true)]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_pagination, {
          class: "pagination",
          onCurrentChange: handleCurrentChange,
          "current-page": currentPage.value,
          "page-size": pageSize.value,
          total: total.value,
          layout: "total,  prev, pager, next, jumper"
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: isVisible.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => isVisible.value = $event),
        onClosed: _cache[13] || (_cache[13] = () => resetForm()),
        "close-on-click-modal": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_form, {
          model: form.value,
          "label-width": "150px",
          rules: rules.value,
          ref_key: "formEl",
          ref: formEl
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "回复类型"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.value.replyType,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.replyType = $event),
              placeholder: "请选择回复类型"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "文本",
                value: "text"
              }), _createVNode(_component_el_option, {
                label: "图片",
                value: "image"
              }), _createVNode(_component_el_option, {
                label: "图文",
                value: "news"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "关键字",
            prop: "keyword"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.keyword,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.keyword = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), form.value.replyType === 'text' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "内容",
            prop: "value"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              autosize: {
                minRows: 5,
                maxRows: 100
              },
              resize: "none",
              modelValue: form.value.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.value = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), form.value.replyType === 'image' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "图片选择"
          }, {
            default: _withCtx(() => [currentSelectImage.value.url ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "image-box",
              onMouseenter: _cache[5] || (_cache[5] = $event => markShow.value = true),
              onMouseleave: _cache[6] || (_cache[6] = $event => markShow.value = false)
            }, [_createElementVNode("img", {
              src: currentSelectImage.value.url,
              alt: "",
              class: "image",
              ref: "imageRef",
              referrerpolicy: "no-referrer"
            }, null, 8, _hoisted_6), _createVNode(_Transition, {
              name: "fade"
            }, {
              default: _withCtx(() => [markShow.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_icon, {
                onClick: delCurrentSelectImage,
                color: "#ffffff",
                size: 20,
                class: "icon"
              }, {
                default: _withCtx(() => [_createVNode(_unref(Delete))]),
                _: 1
              }), _createVNode(_component_el_icon, {
                onClick: previewCurrentSelectImage,
                color: "#ffffff",
                size: 20,
                class: "icon"
              }, {
                default: _withCtx(() => [_createVNode(_unref(ZoomIn))]),
                _: 1
              })])) : _createCommentVNode("", true)]),
              _: 1
            })], 32)) : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "select-image-box",
              onClick: imageSelectHandler
            }, [_createVNode(_component_el_icon, {
              size: 30
            }, {
              default: _withCtx(() => [_createVNode(_unref(Plus))]),
              _: 1
            })]))]),
            _: 1
          })) : _createCommentVNode("", true), form.value.replyType === 'news' ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 2
          }, _renderList(newsGroupNum.value, item => {
            var _title$value;
            return _openBlock(), _createElementBlock(_Fragment, {
              key: item
            }, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", null, _toDisplayString((_title$value = title.value[newsGroupNum.value - 1]) !== null && _title$value !== void 0 && _title$value.select ? '素材选择' : '自定义'), 1), _hoisted_10]), _createVNode(_component_el_form_item, {
              prop: `title${item}`,
              label: "标题"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value[`title${item}`],
                "onUpdate:modelValue": $event => form.value[`title${item}`] = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 2
            }, 1032, ["prop"]), _createVNode(_component_el_form_item, {
              prop: `description${item}`,
              label: "描述"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value[`description${item}`],
                "onUpdate:modelValue": $event => form.value[`description${item}`] = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 2
            }, 1032, ["prop"]), _createVNode(_component_el_form_item, {
              prop: `picUrl${item}`,
              label: "图片url"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value[`picUrl${item}`],
                "onUpdate:modelValue": $event => form.value[`picUrl${item}`] = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 2
            }, 1032, ["prop"]), _createVNode(_component_el_form_item, {
              prop: `url${item}`,
              label: "地址url"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value[`url${item}`],
                "onUpdate:modelValue": $event => form.value[`url${item}`] = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
              _: 2
            }, 1032, ["prop"])], 64);
          }), 128)) : _createCommentVNode("", true), form.value.replyType === 'news' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 3
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "success",
              onClick: _cache[7] || (_cache[7] = $event => isSelectNewsVisible.value = true)
            }, {
              default: _withCtx(() => [_createTextVNode(" 选择素材 ")]),
              _: 1
            }), _createVNode(_component_el_button, {
              text: "",
              type: "success",
              onClick: _cache[8] || (_cache[8] = $event => addGroupHandler())
            }, {
              default: _withCtx(() => [_createTextVNode(" 添加一组 ")]),
              _: 1
            }), _createVNode(_component_el_button, {
              text: "",
              onClick: _cache[9] || (_cache[9] = $event => isUrlSelectVisible.value = true)
            }, {
              default: _withCtx(() => [_createTextVNode(" 选择地址url ")]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: createGreetingHandler
            }, {
              default: _withCtx(() => [_createTextVNode(" 确认 ")]),
              _: 1
            }), _createVNode(_component_el_button, {
              onClick: _cache[10] || (_cache[10] = $event => isVisible.value = false)
            }, {
              default: _withCtx(() => [_createTextVNode("取消")]),
              _: 1
            }), form.value.replyType === 'text' ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              text: "",
              onClick: _cache[11] || (_cache[11] = $event => isUrlTextSelectVisible.value = true)
            }, {
              default: _withCtx(() => [_createTextVNode(" 选择url ")]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: isPreview.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => isPreview.value = $event),
        "close-on-click-modal": false
      }, {
        default: _withCtx(() => [_createVNode(_component_el_image, {
          src: currentSelectImage.value.url
        }, null, 8, ["src"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_unref(urlDialog), {
        modelValue: isUrlSelectVisible.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => isUrlSelectVisible.value = $event),
        onConfirm: onUrlSelectConfirm
      }, null, 8, ["modelValue"]), _createVNode(_unref(urlDialog), {
        modelValue: isUrlTextSelectVisible.value,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => isUrlTextSelectVisible.value = $event),
        onConfirm: onUrlTextSelectConfirm
      }, null, 8, ["modelValue"])]);
    };
  }
};